export const AUTH_LOAD_COMPANY_BILLING_INFO = 'AUTH_LOAD_COMPANY_BILLING_INFO'
export const AUTH_LOGGED_IN = 'AUTH_LOGGED_IN'